<cs-header>
  <cs-header-title>{{ LL.subscribe.messages.installAppPromptTitle() }}</cs-header-title>
</cs-header>

<cs-content>
  <p class="purchase-success__body">{{ LL.subscribe.messages.installAppPromptBody() }}</p>
  <cs-store-badges [androidInstallUrl]="androidInstallUrl" [iosInstallUrl]="iosInstallUrl"></cs-store-badges>
</cs-content>

<cs-page-action-buttons>
  <cs-button medium primary [label]="LL.subscribe.messages.continueAfterPurchase()" (click)="onContinueClick()"></cs-button>
</cs-page-action-buttons>
